export const specialSchedules = [
  { id: '#-SHARE', label: 'SHARE' },
  { id: '#-EXAMS', label: 'Exams' },
  { id: '#-SUMMERBREAK', label: 'Summer' },
  { id: '#-SPRINGBREAK', label: 'Spring' },
  { id: '#-WINTERBREAK', label: 'Winter' },
  { id: '#-BREAK', label: 'Other break' },
  { id: '#-THANKSGIVING', label: 'Thanksgiving' },
];
